import Select from "react-select"
import React, { useEffect, useState } from "react"
import { getCountryOptions } from "common/SelectOptions/countryOptions"
import { getSystemOptions } from "common/SelectOptions/systemOptions"
import {getPolicyTypeOptions} from "../../common/SelectOptions/policyTypeOptions";
import {policyScopeOptions} from "../../common/SelectOptions/policyScopeOptions";
import {policyImplementationStatusOptions} from "../../common/SelectOptions/policyImplementationStatusOptions";

const PublicPolicyDirectoryFilters = ({
  appliedFilters, 
  applyFilters,
}) => {
  const [locationOptions, setLocationOptions] = useState([]);
  const [systemOptions, setSystemOptions] = useState([]);
  const [policyTypeOptions, setPolicyTypeOptions] = useState([])
  const [filters, setFilters] = useState(appliedFilters);

  const handleChange = (options, field) => {
    setFilters((prev)=>({
      ...prev,
      [field]: options
    }))
  }

  useEffect(() => {
    const fetchOptions = async () => {
      setLocationOptions(await getCountryOptions());
      setSystemOptions(await getSystemOptions());
      setPolicyTypeOptions(await getPolicyTypeOptions());
    };
    fetchOptions();
  }, []);

  return (
    <div>
      {/* Filter by Location */}
      <div className="mb-6">
        <div className="flex items-center mb-2">
          <i className="mdi mdi-map-marker-outline mr-1" />
          <h6 className="font-medium">Countries:</h6>
        </div>
        <div className="w-full">
          <Select
            isMulti
            options={locationOptions}
            defaultValue={filters.countries}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select countries"
            onChange={options => handleChange(options, 'countries')}
          />
        </div>
      </div>

      {/* Filter by Systems */}
      <div className="mb-6">
        <div className="flex items-center mb-2">
          <i className="mdi mdi-cog-outline mr-1" />
          <h6 className="font-medium">Systems:</h6>
        </div>
        <div className="w-full">
          <Select
            isMulti
            options={systemOptions}
            defaultValue={filters.systems}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select systems"
            onChange={options => handleChange(options, 'systems')}
          />
        </div>
      </div>

      {/* Filter by Policy Type */}
      <div className="mb-6">
        <div className="flex items-center mb-2">
          <i className="mdi mdi-file-document-outline mr-1" />
          <h6 className="font-medium">Policy Types:</h6>
        </div>
        <div className="w-full">
          <Select
            isMulti
            options={policyTypeOptions}
            defaultValue={filters.policyTypes}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select policy types"
            onChange={options => handleChange(options, 'policyTypes')}
          />
        </div>
      </div>

      {/* Filter by Policy Scope */}
      <div className="mb-6">
        <div className="flex items-center mb-2">
          <i className="mdi mdi-eye-outline mr-1" />
          <h6 className="font-medium">Policy Scopes:</h6>
        </div>
        <div className="w-full">
          <Select
            isMulti
            options={policyScopeOptions}
            defaultValue={filters.policyScopes}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select Policy Scopes"
            onChange={options => handleChange(options, 'policyScopes')}
          />
        </div>
      </div>

      {/* Filter by Implementation Status */}
      <div className="mb-6">
        <div className="flex items-center mb-2">
          <i className="mdi mdi-timeline-outline mr-1" />
          <h6 className="font-medium">Implementation Status:</h6>
        </div>
        <div className="w-full">
          <Select
            isMulti
            options={policyImplementationStatusOptions}
            defaultValue={filters.implementationStatus}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select Implementation Status"
            onChange={options => handleChange(options, 'implementationStatus')}
          />
        </div>
      </div>

      {/* Apply Filters Button */}
      <div className="flex justify-center mt-6">
        <button
          className="w-full sm:w-3/4 common-button"
          onClick={()=>applyFilters(filters)}
        >
          Apply
        </button>
      </div>
    </div>
  )
}

export default PublicPolicyDirectoryFilters
